import { render, staticRenderFns } from "./CarouselWrapper.vue?vue&type=template&id=28fa38f6&scoped=true&"
import script from "./CarouselWrapper.vue?vue&type=script&lang=js&"
export * from "./CarouselWrapper.vue?vue&type=script&lang=js&"
import style0 from "./CarouselWrapper.vue?vue&type=style&index=0&id=28fa38f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28fa38f6",
  null
  
)

export default component.exports